import React, { useState } from 'react';

import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import Modal from './modal';

export default function ActivityCreation() {
  const [showModal, setShowModal] = useState();

  return <>
    <Button icon={faCirclePlus} label="Add activity" size="sm" variant="ghost" onClick={() => setShowModal(true)} />
    <Modal show={showModal} onClose={() => setShowModal(false)} />
  </>;
}
